import { useEffect, useState } from 'react';
import secureLocalStorage from 'react-secure-storage';
import { HttpRequest } from '../components/HttpRequest';

const CACHE_KEY = 'zed_billing_status';
const CACHE_TTL_MS = 5 * 60 * 1000;

/**
 * Fetches the shop's ZED billing status (Active | Grace | Expired | Inactive).
 * Cached in sessionStorage for 5 minutes. Fails open to Active — a billing check
 * must never take the storefront down by accident.
 */
const useBillingStatus = () => {
    const [billing, setBilling] = useState({ billingStatus: 'Active', graceDaysRemaining: null, dueDate: null, enforced: false, loaded: false });

    useEffect(() => {
        const businessNumber = secureLocalStorage.getItem('businessId');
        if (!businessNumber) {
            setBilling((prev) => ({ ...prev, loaded: true }));
            return;
        }

        try {
            const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
            if (cached && cached.businessNumber === businessNumber && cached.expiresAt > Date.now()) {
                setBilling({ ...cached.data, loaded: true });
                return;
            }
        } catch (e) { /* ignore bad cache */ }

        HttpRequest({
            method: 'GET',
            url: `/api/v1/ecommerce/billing-status?businessNumber=${businessNumber}`,
        }).then((response) => {
            const data = response?.response?.data || { billingStatus: 'Active', graceDaysRemaining: null, dueDate: null, enforced: false };
            sessionStorage.setItem(CACHE_KEY, JSON.stringify({ businessNumber, data, expiresAt: Date.now() + CACHE_TTL_MS }));
            setBilling({ ...data, loaded: true });
        }).catch(() => {
            setBilling((prev) => ({ ...prev, loaded: true }));
        });
    }, []);

    return billing;
};

export default useBillingStatus;
